import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { GoogleProp } from '../../../types/google';
import { useContext, useState } from 'react';
import { AuthContext } from '../../../hooks/authContext';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../../enums/Approutes';
import { LoadingButton } from '@mui/lab'
import GoogleIcon from '@mui/icons-material/Google';
import { useToast } from '../../../hooks/useToast';
import { getConfig } from '../../../config/env';

const GoogleButton: React.FC<GoogleProp> = ({ text, sponsor_code }) => {
    const url = getConfig().BASE_URL;
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const { login } = useContext(AuthContext);
    const { googleError } = useToast();

    const handleGoogleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse: any) => {
            try {
                setLoading(true);
                const { access_token } = tokenResponse;
                if (!access_token) {
                    throw new Error('Google token is missing');
                }

                const payload = {
                    access_token: access_token,
                    ...(sponsor_code && { sponsor_code: sponsor_code })
                };

                const response = await axios.post(`${url}/users/signup_with_google/`, payload);
                const { token } = response.data;
                const responseUser = await axios.get(`${url}/users/auth/profile/`, { headers: { Authorization: `Bearer ${token.access}` } });
                const user_data = responseUser.data;
                login(token.access, user_data.id);

                if (user_data.birth_date) {
                    // Pulisci eventuale contesto residuo
                    sessionStorage.removeItem('googleAuthContext');
                    setLoading(false);
                    navigate(AppRoutes.PIN_MAP);
                } else {
                    // Persisti un piccolo contesto per sopravvivere al refresh
                    const googleAuthContext = {
                        first_name: user_data.first_name,
                        last_name: user_data.last_name,
                        email: user_data.email,
                        sponsor_code: sponsor_code,
                        isGoogleAuth: true,
                        is_verified: user_data.is_verified
                    };
                    sessionStorage.setItem('googleAuthContext', JSON.stringify(googleAuthContext));
                    setLoading(false);
                    navigate(AppRoutes.WELCOME, {
                        state: {
                            first_name: user_data.first_name,
                            last_name: user_data.last_name,
                            email: user_data.email,
                            sponsor_code: sponsor_code,
                            isGoogleAuth: true, // Flag per identificare il flusso Google
                            is_verified: user_data.is_verified // Flag dal backend
                        }
                    });
                }
            } catch (error) {
                console.error(error);
                googleError();
                setLoading(false);
            }
        },
        onError: () => {
            googleError();
        }
    });

    return (
        <LoadingButton
            loading={loading}
            onClick={() => handleGoogleLogin()}
            fullWidth
            startIcon={
                <GoogleIcon sx={{ color: '#E9495A' }} />
            }
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'trasparent',
                color: '#1A1A1A',
                border: '0.08rem solid #E0E0E0',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: { xs: '0.875rem', sm: '0.9rem' },
                '&:hover': {
                    backgroundColor: 'white',
                    border: '0.08rem solid #E9495A'
                }
            }}
        >
            {text}
        </LoadingButton>
    );
};

export default GoogleButton;
